import { tourStep } from './tourRegistry';

export const bandaMetricasSteps = [
  tourStep(
    'metricas-header',
    'Estadísticas',
    'Informe de asistencia y actividad de la agrupación en un periodo. Puedes exportarlo a PDF o compartir un resumen.',
  ),
  tourStep(
    'metricas-wizard',
    'Elige el periodo',
    'Año, mes o rango de fechas. Luego puedes comparar con el periodo anterior y generar el informe.',
  ),
];
